// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type {
    GetMainProductsQuery,
    BaseResponseListMainProductFoundResponse,
    PostMainProductsBody,
    BaseResponseMainProductFoundResponse,
} from '../types';

/**
 * findAll
 *
 * @export
 * @tags main-product-controller
 * @link [GET] /mainProducts
 */
export function getMainProducts(): Promise<BaseResponseListMainProductFoundResponse>;
export function getMainProducts(
    options: ApiOptions<never, GetMainProductsQuery>
): Promise<BaseResponseListMainProductFoundResponse>;
export function getMainProducts(
    options?: ApiOptions<never, GetMainProductsQuery>
): Promise<BaseResponseListMainProductFoundResponse> {
    return request<never, never, GetMainProductsQuery>('/mainProducts', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getMainProducts',
    });
}

/**
 * save
 *
 * @export
 * @tags main-product-controller
 * @link [POST] /mainProducts
 */
export function postMainProducts(
    data: PostMainProductsBody
): Promise<BaseResponseMainProductFoundResponse>;
export function postMainProducts(
    data: PostMainProductsBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseMainProductFoundResponse>;
export function postMainProducts(
    data: PostMainProductsBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseMainProductFoundResponse> {
    return request<PostMainProductsBody, never, never>('/mainProducts', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postMainProducts',
    });
}

export const meta = [
    { tags: ['main-product-controller'], path: '/mainProducts', method: 'get' },
    { tags: ['main-product-controller'], path: '/mainProducts', method: 'post' },
];
